// src/components/iaDashboard/cards/PendingSessionsCard.jsx
import React from "react";

export default function PendingSessionsCard({ value, realtimeValue }) {
  const display = realtimeValue ?? value ?? 0;

  return (
    <div className="ia-card ia-card-pending">
      <div className="ia-card-header">
        <span className="ia-card-label">Pendentes na fila</span>
        <span className="ia-card-chip ia-card-chip-alert">SLA</span>
      </div>
      <div className="ia-card-value">{display}</div>
      <p className="ia-card-sub">
        Usuários aguardando atendimento humano. Fique de olho no SLA.
      </p>
    </div>
  );
}
